import { render, staticRenderFns } from "./row-element.vue?vue&type=template&id=b5c823f0&scoped=true&"
import script from "./row-element.vue?vue&type=script&lang=js&"
export * from "./row-element.vue?vue&type=script&lang=js&"
import style0 from "./row-element.vue?vue&type=style&index=0&id=b5c823f0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c823f0",
  null
  
)

export default component.exports